const AuthRoutes = {
  login:"/Token",
  getTrainsById:"/Train/GetTrainStationsByTrainId",
  getTrains:"/Train/GetLiveTrains",
  getAllLocomotive: 'Train/GetLiveTrainsForDashboard?offset=0&limit=500',

  getTrainDepartureArrivalLog: "/TrainLocationLog/getTrainDelayLog",
  updateFlag: "/trainRide/trainFlagAction",
};

export default AuthRoutes;